module.exports = __webpack_public_path__ + "img/powered.d061524e.svg";